import i18next from 'i18next';

export default function statusCustomerTranslation(value) {
    if (value) {
        return i18next.t('_common:terms.statusActive');
    }
    return i18next.t('_common:terms.statusInactive');
}
